/** Sdílené React Query klíče submodulu Vehicles (napříč okny `list/` + `detail/`). */

/**
 * Klíč ListPage configu vozů — zároveň prefix React Query klíčů seznamu
 * (`[VEHICLE_LIST_KEY, 'list' | 'stats', …]`). Slouží k invalidaci seznamu po uložení detailu.
 */
export const VEHICLE_LIST_KEY = 'inventory.vehicles';
